var exports = {
  "k": "x9bf38834--28c858--container",
};

module.exports = exports;
